import React, { Suspense } from 'react';
import '../styles/App.css';
import { BrowserRouter as Router, Route, Routes,useNavigate } from 'react-router-dom';
import Home from '../components/Home';
import AuthServices from '../services/AuthServices';
import navigationServices from "../services/navigationServices";
import { useState,useEffect } from 'react'
import { NotificationProvider } from '../components/NotificationProvider';
import InstallExtensionBanner from '../components/InstallExtensionBanner';
import { BUILD_TIMESTAMP } from '../timestamp';

const Inscription = React.lazy(() => import('../components/Inscription'));
const UrlImporterTest = React.lazy(() => import('../components/UrlImporterTest'));
const ShareReceiver = React.lazy(() => import('../components/share-receiver'));
const StatsPage = React.lazy(() => import('../components/StatsPage'));
const ConfirmationInscription = React.lazy(() => import('../components/ConfirmationInscription'));
const Preferences = React.lazy(() => import('../components/Preferences'));
const AdminUserReport = React.lazy(() => import('../components/AdminUserReport'));
//import UrlImporter from './UrlImporter';
// import Product from '../components/Product';
// import ListUserMock from '../datas/ListUserMock';

function App() {

  const [user, setUser] = useState(undefined)
  const [isProprio, setIsProprio] = useState(false)
  const [readonlyKey, setReadonlyKey] = useState(undefined)
  const [isDataRegistering, setIsDataRegistering] = useState(false)
  const [isError, setError] = useState(false)
  const [connectionErrorMessage, setConnectionErrorMessage] = useState(null)
  const [connexionKey, setkey] = useState(null)
  const [roles, setRoles] = useState(null)
  const [showUpdateBanner, setShowUpdateBanner] = useState(false)
  const [latestBuild, setLatestBuild] = useState(null);
  const [urlImporter, setUrlImporter] = useState(null);
  const [shouldCleanKeyFromUrl, setShouldCleanKeyFromUrl] = useState(false);
  const [viewKey, setViewKey] = useState(null);
  const [sharedListId, setSharedListId] = useState(null);
  const [sharedOwnerName, setSharedOwnerName] = useState(null);
  const maintenanceMessage = "Les serveurs sont temporairement indisponibles pour cause de maintenance. Merci de reessayer un peu plus tard.";
  
  const NavigationInitializer = () => {
    const navigate = useNavigate();
    navigationServices.setGlobalNavigate(navigate);
    return null; // Ce composant n'affiche rien
  };

  const params = new URLSearchParams(window.location.search);
  const urlKey = params.get('key');
  const urlIdList = params.get('idList');
  // console.log(params.toString()); // Prints 'foo=1&bar=2&foo=4'
  // const v_user = params.get('user');
  // if (v_user !== null) {
  //   if(v_user !== user){
  //     setUser(v_user);
  //   }
  // } else if (user === undefined) { 
  //   setUser('usertest');
  // }

  useEffect(() => {
    //Si c'est une cle proprio on la garde (même s'il y en avait une autre avant)
    //Si c'est une clé en lecture on ne la garde pas
    //Si c'est la clé Démo (987654321) on ne la garde pas
    if(isProprio && connexionKey!== "987654321")
      {
        console.log("On conserve la connexion")
        //Si l'utilisateur s'est connecté sur sont compte, on garde sa clé pour la prochaine fois
        AuthServices.setConnectedKey(connexionKey);
      }
  }, [isProprio])

  useEffect(() => {
    if(!connexionKey)
      {
        console.log("On a plus de key, on vide le user")
        setUser(null);
      }
  }, [connexionKey])

  useEffect(() => {
    let isCancelled = false;

    const runCheck = async () => {
      try {
        const response = await fetch('/version.json', { cache: 'no-store' });
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        if (isCancelled) {
          return;
        }
        const remoteBuild = data?.BUILD_TIMESTAMP;
        if (typeof remoteBuild === 'string') {
          setLatestBuild(data?.generatedAtISO);
          if (remoteBuild > BUILD_TIMESTAMP) {
            setShowUpdateBanner(true);
          } else {
            setShowUpdateBanner(false);
          }
        }
      } catch (err) {
        console.warn('Version check failed', err);
      }
    };

    
    setUrlImporter(params.get('url'));
    console.log("URL Importer param: "+params.get('url'));

    runCheck();
    const intervalId = window.setInterval(runCheck, 10 * 60 * 1000); // toutes les 10 minutes

    return () => {
      isCancelled = true;
      window.clearInterval(intervalId);
    };
  }, [])

  useEffect(() => {
    if (!urlKey) {
      setViewKey(null);
      setSharedListId(null);
      setSharedOwnerName(null);
      return;
    }
    const ownerKey = AuthServices.getConnectedKey() || connexionKey;
    if (ownerKey && urlKey !== ownerKey) {
      setViewKey(urlKey);
      setSharedListId(urlIdList);
    } else {
      setViewKey(null);
      setSharedListId(urlIdList);
      setSharedOwnerName(null);
    }
  }, [urlKey, urlIdList, connexionKey]);

  useEffect(() => {
    const ownerKey = AuthServices.getConnectedKey() || connexionKey;
    if (!viewKey || (ownerKey && viewKey === ownerKey)) {
      setSharedOwnerName(null);
      return;
    }
    const controller = new AbortController();
    const requestOptions = {
      method: "POST",
      mode: 'cors',
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        key: viewKey
      }),
      signal: controller.signal,
    };

    const fetchSharedOwner = async () => {
      try {
        const response = await fetch("https://app.listaki.fr/api/WS/getInfosUserByKey.php?key=" + viewKey, requestOptions);
        if (!response.ok) {
          setSharedOwnerName(null);
          return;
        }
        const data = await response.json();
        setSharedOwnerName(data?.username || null);
      } catch (err) {
        if (err && err.name !== "AbortError") {
          console.warn("Erreur getInfosUserByKey pour la liste partagee", err);
        }
        setSharedOwnerName(null);
      }
    };

    fetchSharedOwner();
    return () => controller.abort();
  }, [viewKey, connexionKey]);

  const handleRefreshNow = () => {
    window.location.reload();
  };

if(!connexionKey)
  {
    const v_urlKey = params.get('key')
    if(v_urlKey)
      {
        setkey(v_urlKey);
        setShouldCleanKeyFromUrl(true);
        // console.log(v_urlKey);
        // console.log(connexionKey);
        // console.log(user);
      }    
      else
      {
        const v_localkey = AuthServices.getConnectedKey();
        if(v_localkey)
        {
          setkey(v_localkey);
        }
      }
  }

  useEffect(() => {
    if(!shouldCleanKeyFromUrl || !isProprio) return;
    try {
      const cleanUrl = new URL(window.location.href);
      if(!cleanUrl.searchParams.has('key')) {
        setShouldCleanKeyFromUrl(false);
        return;
      }
      if (viewKey && cleanUrl.searchParams.get('key') !== connexionKey) {
        setShouldCleanKeyFromUrl(false);
        return;
      }
      cleanUrl.searchParams.delete('key');
      const nextPath = `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`;
      window.history.replaceState({}, document.title, nextPath || "/");
    } catch (err) {
      console.warn("Impossible de nettoyer la clé dans l'URL", err);
    } finally {
      setShouldCleanKeyFromUrl(false);
    }
  }, [shouldCleanKeyFromUrl, isProprio, viewKey, connexionKey]);
  
  if (!user && connexionKey !== null && !isError && !isDataRegistering) {
    const v_infosUser = getInfosUserByKey(connexionKey);
    // console.log("isError "+isError);
    if(v_infosUser !== undefined){
      setIsProprio(v_infosUser.isProprio);
      // console.log("isProprio " + isProprio)
      setUser(v_infosUser.username);
      setReadonlyKey(v_infosUser.readonlyKey);
    }else
    {
      if(isProprio === true)
      { 
        setIsProprio(false);
      }
      AuthServices.logout(); //Si pas de user pour la key ont la supprime
      setkey(null);
    }
  } 

    async function getInfosUserByKey(p_key) {

        // console.log("getInfosUserByKey debut : "+p_key);
        if(isError !== true){
          const controller = new AbortController();
          const requestOptions = {
              method: "POST",
              mode: 'cors',
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                key: p_key
              }),
              signal: controller.signal,
          };

          let timeoutId;
          try {
              let v_responseJson = {};
              setIsDataRegistering(true);
              timeoutId = window.setTimeout(() => controller.abort(), 10000);
              const response = await fetch("https://app.listaki.fr/api/WS/getInfosUserByKey.php?key="+p_key, requestOptions)
              if (response.ok) {
                  v_responseJson = await response.json();
                  // console.log("Reponse api debut");
                  // console.log(v_responseJson)
                  // console.log("Reponse api fin");
                  
                  setIsProprio(v_responseJson.isProprio);
                  setUser(v_responseJson.username);
                  setReadonlyKey(v_responseJson.readonlyKey);
                  setRoles(v_responseJson.roles);
                  setError(false);
                  setConnectionErrorMessage(null);
              } else {
                  console.log("Erreur lors de l'appel a l'API");
                  setError(true);
                  setConnectionErrorMessage(maintenanceMessage);
              }
          } catch (err) {
              setError(true);
              setConnectionErrorMessage(maintenanceMessage);
              if (err && err.name === "AbortError") {
                console.log("Requete utilisateur interrompue apres 10 secondes.");
              } else {
                console.log(err);
              }
          } finally {
            if(timeoutId){
              window.clearTimeout(timeoutId);
            }
            setIsDataRegistering(false);
          }
      }
    };

  return (
    <NotificationProvider>
      {showUpdateBanner && (
        <div className="update-banner" role="status" aria-live="polite">
          <span>
            Un nouvelle version est disponible&nbsp;-&nbsp;Rechargez !
            {latestBuild && (
              <>
                &nbsp;({latestBuild} )
              </>
            )}
          </span>
          <div className="update-actions">
            <a href="https://listaki.fr/changelog/" target="_blank" rel="noopener noreferrer" className="linklike">Voir les nouveautés</a>
            <button onClick={handleRefreshNow}>Recharger</button>
          </div>
        </div>
      )}
      {isError && (
        <div className="backend-warning" role="alert">
          <h2>Maintenance en cours</h2>
          <p>{connectionErrorMessage || maintenanceMessage}</p>
          <button className="kdo-button" onClick={handleRefreshNow}>Recharger</button>
        </div>
      )}
      <InstallExtensionBanner />
      <Router>
        <NavigationInitializer /> {/* Initialise la navigation globale */}
        <Suspense fallback={<div>Chargement...</div>}>
          <Routes>
            <Route path="/" element={<Home p_user={user} p_key={viewKey || connexionKey} p_setkey={setkey} p_isProprio={isProprio} p_readonlyKey={readonlyKey} p_roles={roles} p_isReadOnlyView={Boolean(viewKey)} p_sharedListId={sharedListId} p_ownerKey={connexionKey} p_sharedOwnerName={sharedOwnerName} />} />
            <Route path="/register" element={<Inscription/>} />
            <Route path="/test" element={<UrlImporterTest/>} />
            <Route path="/import" element={<Home p_user={user} p_key={viewKey || connexionKey} p_setkey={setkey} p_isProprio={isProprio} p_readonlyKey={readonlyKey} p_roles={roles} p_url={urlImporter} p_isReadOnlyView={Boolean(viewKey)} p_sharedListId={sharedListId} p_ownerKey={connexionKey} p_sharedOwnerName={sharedOwnerName} />} />
            <Route path="/share-receiver" element={<ShareReceiver />} />
            {/* <Route path="/product/:id" component={Product} /> */}
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/report" element={<AdminUserReport />} />
            <Route path="/preferences" element={<Preferences />} />
            <Route path="/confirmation-inscription" element={<ConfirmationInscription />} />
          </Routes>
        </Suspense>
      </Router>
    </NotificationProvider>
  );
}

export default App;
